export default {
  label: {
    notClassifiedLabels: ['Unclassified', 'Unclassified'],
    notShowClassifiedLabel: 'Show unclassified',
    showClassifiedLabel: 'Hide unclassified',
    noData: 'No data available',
  },
};
